module.exports = __webpack_public_path__ + "static/media/rectangle-22.ce28b3be.svg";